import EntryPoint from '../views/entrypoint.vue'
import Login from '../views/login.vue'
import Scripts from '@/core/list/views/scripts.vue'
import Pass from '@/core/pass/views/pass.vue'

const routes = [
  {
    path: '/iframe/login',
    name: 'iframeLogin',
    component: Login,
  },
  {
    path: '/iframe',
    component: EntryPoint,
    children: [
      {
        path: '',
        name: 'iframeScripts',
        components: {core: Scripts},
      },
      {
        path: 'script/:id',
        name: 'iframePass',
        components: {core: Pass},
      },
    ],
  },
]

export default routes
